
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Box, Button, Chip, Container, FormControl, FormHelperText, Grid, InputAdornment, ListItem, OutlinedInput, Paper, styled, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import UDataGrid from "../../components/mui/UDataGrid";
import UTextField from "../../components/mui/UTextField";
import { useEffect } from 'react';
import UButton from '../../components/mui/UButton';
import UBreadCrumbs from '../../components/mui/UBreadCrumbs';
import { fnCallPopUp } from '../../services/commonService';
import { PAGE } from '../../config';
import { useState } from 'react';

const columns = [
    { 
      field: 'id',
      headerName: 'No',
      type: 'number', 
      width: 5,
    },
    {
      field: 'machId',
      headerName: 'Machine ID',
      flex: 1,
    },
    {
      field: 'machKndCd',
      headerName: 'model',
      flex: 1,
    },
    {
      field: 'verNo',
      headerName: 'Current Ver',
      flex: 1,
    },
    {
      field: 'result',
      headerName: 'Result',
      flex: 1,
    },
];

const Item = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  
export default function FileUploadPopUpPage(){
    const [chipData, setChipData] = React.useState([]);	
    const [rows, setRows] = useState([]);
    
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            const input = JSON.parse(localStorage.getItem("checkedList"));
            
            input.map();
            // console.log(input);
            //setRows(input.selectedRows);
        } catch (e) {
            console.log(e.message);
        }
        };
        getLoadData();
    }, [""]);
    

    const fnBrowser = () => {
        const element = document.createElement('input');
        element.type = "file";
        element.multiple = true;
        element.onchange = onSaveFiles;
        element.click();
    };


    const handleDelete = (chipToDelete) => () => {
        setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
      };

    const onSaveFiles = (e) => {
        // console.log("파일선택창에서 선택한 파일들?????????????:");
        // console.log(e.target);
        const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들

        const _inputData = uploadFiles.map((m,i)=>({
            key: i,
            label: m.name,
            file: m,
        }));
        setChipData(_inputData);
    };

    const onFileUpload = () => {
        const formData = new FormData();

        chipData.forEach((file) => {
            // 파일 데이터 저장
            formData.append('multipartFiles', file);
        });

        // 객체
        //const dataDto = {
        //};
        //formData.append('stringdataDto', JSON.stringify(dataDto)); // 직렬화하여 객체 저장

        //axios.post('http://localhost:8081/uploadFiles', formData);
    };
    
    return(<>
        <Box sx={{mt:3, ml:4, mb:1 , width:"93%"}}>
            <UBreadCrumbs
                        title={"프로그램관리"}
                        subtitle={"파일업로드"} 
            />
        </Box>
        
        <Box sx={{mt:3, ml:4, width:"93%"}}>
            
            <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                      
                            
        <UDataGrid columns={columns} data={rows} />
                </FormControl>
            <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <OutlinedInput
                    id="outlined-adornment-weight"
                    startAdornment={<InputAdornment position="start">파일경로</InputAdornment>}
                    aria-describedby="outlined-weight-helper-text"
                />
            </FormControl>
            <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <Box sx={{
                    display: 'flex',
                    //justifyContent: 'center',
                    flexWrap: 'wrap',
                    listStyle: 'none',
                    p: '6px',
                    m: 0,
                    border: '1px solid',
                    borderRadius: '4px',
                    color: 'rgba(0, 0, 0, 0.23)',

                }}>
                     <Button variant='text'
                           onClick={()=>fnBrowser()}
                        >파일선택</Button>
                        {chipData && chipData.map((data) => {
                            let icon;

                            //if (data.label === 'React') {
                            //icon = <TagFacesIcon />;
                            //}

                            return (
                                <Grid>
                                <ListItem key={data.key}>
                                    <Chip
                                    icon={icon}
                                    label={data.label}
                                    //onDelete={data.label === 'React' ? undefined : handleDelete(data)}
                                    onDelete={handleDelete(data)}
                                    />
                                </ListItem>
                                </Grid>
                            );
                        })}
                </Box>
            </FormControl>
            <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
                <OutlinedInput
                    id="outlined-adornment-weight"
                    startAdornment={<InputAdornment position="start">Description</InputAdornment>}
                    aria-describedby="outlined-weight-helper-text"
                    multiline
                    rows={2}
                />
            </FormControl>
            <FormControl sx={{ ml: "50%", mt:2 }} variant="outlined">
                <Button variant='contained'>실행</Button>
            </FormControl>
        </Box>
    </>
    );
}